import { render, staticRenderFns } from "./SellerCreatives.vue?vue&type=template&id=13212098&scoped=true"
import script from "./SellerCreatives.vue?vue&type=script&lang=js"
export * from "./SellerCreatives.vue?vue&type=script&lang=js"
import style0 from "./SellerCreatives.vue?vue&type=style&index=0&id=13212098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13212098",
  null
  
)

export default component.exports